export default __webpack_public_path__ + "static/media/hamburger.bde5c876.svg";